import { Flex, Text } from '@chakra-ui/react';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { colors } from 'packages/common-frontend/colors';
import { Icon } from 'packages/common-frontend/components/icons';
import {
  PortfolioCovenantQueryInputType,
  queryInputTypeToIcon,
} from 'packages/settings/ui/AddQueryInputModal';

export const QueryInputTypeBadge = ({
  type,
}: {
  type: PortfolioCovenantQueryInputType;
}) => {
  const queryInputTypeDetails = queryInputTypeToIcon[type];
  return (
    <Flex
      borderWidth="1px"
      borderColor={colors.gray[200]}
      borderRadius="32px"
      alignItems="center"
      p="8px 24px"
      color={colors.black[70]}
    >
      <Icon icon={queryInputTypeDetails.icon} />
      <Text ml="8px">
        {queryInputTypeDetails.label ??
          commonUtils.toTitleCase(queryInputTypeDetails.type)}
      </Text>
    </Flex>
  );
};
